import React from "react";
import { useHistory } from "react-router-dom";
import { store } from "../..";
import { ReactComponent as Logo } from "../../assets/icons/Group 1.svg";
import { ReactComponent as Location } from "../../assets/icons/location.svg";
import { ReactComponent as Phone } from "../../assets/icons/phone.svg";
import { loginPage } from "../../Redux/Actions/Authentication";

const texts = {
  companyNumber: "021-88846186",
  address:
    "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است",
  company:
    "کنتور یک برنامه و سامانه بسیار کاربردی ، آسان و رایگان است و از میزان مصرف قبض ها جداگانه و یا تجمیعی گزارش گیری کنید.",
};

const Links = {
  payment: [
    { text: "قبض برق", page: `/Payment/Electricity`, companyId: 3 },
    { text: "قبض گاز", page: `/Payment/Gas`, companyId: 2 },
    { text: "قبض آب", page: `/Payment/Water`, companyId: 1 },
    { text: "قبض تلفن", page: `/Payment/Telephone`, companyId: 5 },
    { text: "قبض موبایل", page: `/Payment/Mobile`, companyId: 4 },
  ],
  quickAccess: [
    { text: "صفحه اصلی", page: "/" },
    { text: "درباره ما", page: "/aboutUs" },
    { text: "تماس با ما", page: "/contactUs" },
    { text: "قوانین و مقررات", page: "/terms" },
  ],
  quickAccessLogin: [
    { text: "صفحه اصلی", page: "/" },
    { text: "ورود", func: loginPage(true) },
    { text: "درباره ما", page: "/aboutUs" },
    { text: "تماس با ما", page: "/contactUs" },
    { text: "قوانین و مقررات", page: "/terms" },
  ],
};

const FooterLinks = ({ header, items, isLogin }) => {
  let history = useHistory();
  return (
    <div className="footerLinksDiv">
      <span>{header}</span>
      {items.map((i, index) => {
        return (
          <span
            key={`#footerLinks${index}`}
            onClick={() => {
              const state = i.companyId
                ? { header: i.text, companyId: i.companyId }
                : { header: i.text };
              i.page
                ? history.push({
                    pathname: i.page,
                    state: state,
                  })
                : store.dispatch(i.func);
            }}
          >
            {i.text}
          </span>
        );
      })}
    </div>
  );
};

const FooterInfo = () => {
  return (
    <div className="footerInfo">
      <div className="ENamad">
        <img
          id="jxlzfukzfukzjzpejzpefukz"
          style={{ cursor: "pointer" }}
          onClick={() =>
            window.open(
              "https://logo.samandehi.ir/Verify.aspx?id=166776&p=rfthgvkagvkajyoejyoegvka",
              "Popup",
              "toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30"
            )
          }
          alt=""
          src="https://logo.samandehi.ir/logo.aspx?id=166776&p=nbpdwlbqwlbqyndtyndtwlbq"
        />
        {/* <img src={require("../../assets/images/enamad.png")} alt={""} /> */}
        <a
          target="_blank"
          href="https://trustseal.enamad.ir/?id=147743&amp;Code=D939h5EmI9Rnl89Rb3VV"
        >
          <img
            src="https://Trustseal.eNamad.ir/logo.aspx?id=147743&amp;Code=D939h5EmI9Rnl89Rb3VV"
            alt=""
            style={{ cursor: "pointer" }}
            id="D939h5EmI9Rnl89Rb3VV"
          />
        </a>
      </div>
      <div className="footerCompanyInfo">
        <div>
          <span>{texts.companyNumber}</span>
          <Phone />
        </div>
        {/* <div>
          <span>{texts.address}</span>
          <Location />
        </div> */}
      </div>
    </div>
  );
};

const Footer = ({ isLogin }) => {
  const quickAccess = isLogin ? Links.quickAccess : Links.quickAccessLogin;
  return (
    <div className="footer">
      <div>
        <Logo />
        <span>{texts.company}</span>
      </div>
      <div className={"FooterLinksContainer"}>
        <FooterLinks header={"پرداخت قبض"} items={Links.payment} />
        <FooterLinks
          header={"دسترسی سریع"}
          items={quickAccess}
          isLogin={isLogin}
        />
      </div>
      <FooterInfo />
    </div>
  );
};

export default Footer;
